import { render, staticRenderFns } from "./ExportPage.vue?vue&type=template&id=36242474&"
import script from "./ExportPage.vue?vue&type=script&lang=js&"
export * from "./ExportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports